export default "__VITE_ASSET__DN1Q9C8T__"